import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { therapyPlanningAction } from '../../actions/constant';
import therapyPlanningService from '../../../services/apiServices/therapyPlanning/therapyPlanning';

const {
  UPDATE_THERAPY_PLANNING_FAILURE,
  UPDATE_THERAPY_PLANNING_REQUEST,
  UPDATE_THERAPY_PLANNING_SUCCESS,
  UPDATE_THERAPY_PLANNING_LOADING
} = therapyPlanningAction;

function* updateTherapyPlanning(payload: any): SagaReturnType<any> {
  yield put({ type: UPDATE_THERAPY_PLANNING_LOADING});

  try {
    const response = yield call(therapyPlanningService.updateTherapyPlanning, payload?.payload);
    if (response?.status === 200) {
      yield put({ type: UPDATE_THERAPY_PLANNING_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: UPDATE_THERAPY_PLANNING_FAILURE, payload: error });
  }
}

function* updateTherapyPlanningSaga() {
  yield takeEvery(UPDATE_THERAPY_PLANNING_REQUEST, updateTherapyPlanning);
}

export default updateTherapyPlanningSaga;
